import { render } from "./ContactsComments.vue?vue&type=template&id=008028d7"
import script from "./ContactsComments.ts?vue&type=script&lang=js&external"
export * from "./ContactsComments.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__